import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    noContentElementInitialState,
    objectContentElementInitialState,
    updateState,
} from "../../../../common/utils/helpers";

const initialState = {
  packageToModify: { ...objectContentElementInitialState },
  envoiModificationPackage: { ...noContentElementInitialState },
};

/*-------------------------------------------------GET-PACKAGE-TO-MODIFY----------------------------------------------------*/
const getPackageToModify = (state) => {
  return updateState("packageToModify", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const getPackageToModifySuccess = (state, payload) => {
  return updateState("packageToModify", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getPackageToModifyFail = (state, payload) => {
  return updateState("packageToModify", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

/*-------------------------------------------------MODIFICATION-PACKAGE----------------------------------------------------*/
const modificationPackage = (state) => {
  return updateState("envoiModificationPackage", state, {
    ...noContentElementInitialState,
    isLoading: true,
  });
};

const modificationPackageSuccess = (state) => {
  return updateState("envoiModificationPackage", state, {
    isLoading: false,
    isSuccessed: true,
  });
};

const modificationPackageFail = (state, payload) => {
  return updateState("envoiModificationPackage", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const modificationPackageReinitialization = (state) => {
  return updateState("envoiModificationPackage", state, {
    ...noContentElementInitialState,
  });
};

/*************************************************************************** */
const modificationPackageReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------GET-PACKAGE-TO-MODIFY----------------------------------------------------*/
    case ActionsTypes.GET_PACKAGE_TO_MODIFY:
      return getPackageToModify(state, action);
    case ActionsTypes.GET_PACKAGE_TO_MODIFY_SUCCESS:
      return getPackageToModifySuccess(state, action.payload);
    case ActionsTypes.GET_PACKAGE_TO_MODIFY_FAIL:
      return getPackageToModifyFail(state, action.payload);
    /*-------------------------------------------------MODIFICATION-PACKAGE----------------------------------------------------*/
    case ActionsTypes.MODIFICATION_PACKAGE:
      return modificationPackage(state, action);
    case ActionsTypes.MODIFICATION_PACKAGE_SUCCESS:
      return modificationPackageSuccess(state);
    case ActionsTypes.MODIFICATION_PACKAGE_FAIL:
      return modificationPackageFail(state, action.payload);
    case ActionsTypes.MODIFICATION_PACKAGE_REINITIALIZATION:
      return modificationPackageReinitialization(state, action.payload);
    default:
      return state;
  }
};

export default modificationPackageReducer;
